import PropTypes from 'prop-types';

export const ChildrenPropType = {
  children: PropTypes.node,
};

export const ChildrenDefaultProp = {
  children: '',
};
